import React, { Component } from 'react';
// import { TransComponent } from 'my-components';

import { ConfigListContainer } from 'my-containers/admin/config'

class ConfigPage extends Component {

    render() {
        return (
            <div className="portlet light bordered">
                <div className="portlet-body">
                    <div className="row">
                        <div className="col-md-12">
                            <ConfigListContainer/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfigPage;